import { defineComponent as _defineComponent } from 'vue'

export enum OzSideModalSlideDirection {
  EndToStart = 'end-to-start',
  StartToEnd = 'start-to-end',
}

const __default__ = {}

import device from '@@/bits/device'
import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzSideModal',
  props: {
    widthClass: { default: 'w-120' },
    darkMode: { type: [Boolean, String], default: 'auto' },
    topInnerCornerRadius: { default: 12 },
    zIndexClass: { default: undefined },
    hideScrollbar: { type: Boolean, default: false },
    scrollbarOverlay: { type: Boolean, default: false },
    slideDirection: { default: OzSideModalSlideDirection.EndToStart },
    position: { default: 'fixed' }
  },
  emits: ['scrim-click', 'scrim-esc', 'transition:after-enter'],
  setup(__props: any) {

const props = __props as { widthClass: 'w-100' | 'w-120', darkMode: boolean | 'auto', topInnerCornerRadius: 0 | 12, zIndexClass: 'z-modal2' | 'z-sidepanel', hideScrollbar: boolean, scrollbarOverlay: boolean, slideDirection: OzSideModalSlideDirection, position: 'fixed' | 'absolute' }



const scrollbarStyles = computed(() => {
  const defaultScrollbarStyles = [
    'overflow-auto',
    {
      'scrollbar-regular dark:scrollbar-regular-dark': props.darkMode === 'auto',
      'scrollbar-regular': props.darkMode === false,
      'dark:scrollbar-regular-dark': props.darkMode === true,
    },
  ]
  if (props.hideScrollbar) {
    return 'no-scrollbar overflow-auto'
  } else if (props.scrollbarOverlay && device.chrome) {
    return ['scrollbar-overlay', ...defaultScrollbarStyles]
  } else {
    return defaultScrollbarStyles
  }
})



return { __sfc: true,OzSideModalSlideDirection, props, scrollbarStyles, OzOverlay }
}

})